import styled from 'styled-components';
import GridContainerAnimated from '../components/global/gsap/GridContainerAnimated';
import { device } from '../styles/device';
import { GridItem } from '../styles/grid/grid';

interface GridItemProps {
    smallPadding?: boolean;
}

const GridItemContent = styled.div<GridItemProps>`
    box-sizing: border-box;
    display: flex;
    flex: 1;
    align-items: center;
    flex-direction: column;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: ${(props) => props.smallPadding ? '64px' : '72px'};
    padding-bottom: 64px;

    @media ${device.tablet} {
        padding-top: ${(props) => props.smallPadding ? '64px' : '100px'};
        padding-bottom: ${(props) => props.smallPadding ? '64px' : '100px'};
        padding-left: 40px;
        padding-right: 40px;
    }
    @media ${device.laptop} {
        padding-top: ${(props) => props.smallPadding ? '64px' : '145px'};
        padding-bottom: ${(props) => props.smallPadding ? '64px' : '145px'};
    }

    a {
        width: fit-content;
        display: block;
        margin: auto; 
    }
`;

const TalentpoolBlockText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: fit-content;
`;

const TalentpoolBlockHeadline = styled.h2`
    font-size: 28px;
    line-height: 34px;
    font-weight: 700;

    margin-top: 0;
    margin-bottom: 8px;
    
    @media ${device.tablet} {
        font-size: 40px;
        line-height: 45px;
        margin-bottom: 12px;
    }
`;
const TalentpoolBlockDescription = styled.div`
    font-size: 18px;
    line-height: 24px;
    margin-top: 0;
    margin-bottom: 24px;
    color: ${(props) => props.theme.colors.fontBlack};

    p {
      margin: 0;
    }
    
    @media ${device.tablet} {
        font-size: 21px;
        line-height: 32px;
        font-weight: 400;
        margin-bottom: 32px;
    }
`;

interface NewsletterBlockProps {
    acForm: any;
    smallPadding?: boolean;
}

export const NewsletterBlock = ({ acForm, smallPadding }: NewsletterBlockProps) => {

    return (
        <GridContainerAnimated>
            <GridItem>
                <GridItemContent smallPadding={smallPadding}>
                    <TalentpoolBlockText>
                        <TalentpoolBlockHeadline>Die neuesten Jobs und Events in dein Postfach</TalentpoolBlockHeadline>
                        <TalentpoolBlockDescription>Verpasse keine spannenden Jobangebote und Einladungen zu Events.</TalentpoolBlockDescription>
                        {acForm}
                    </TalentpoolBlockText>
                </GridItemContent>
            </GridItem>
        </GridContainerAnimated>);
};
